// import {grayColor} from '../../cmsMainStyle'

const legendStyle = theme => ({

	legendArea: {
		// paddingTop: theme.spacing(1),
		// paddingBottom: theme.spacing(1),
		// paddingLeft: theme.spacing(2),
	},

	labelArea: {
		position: "relative",
		marginTop: "8px",
	},

	outlineArea: {
		position: "relative"
	},

	content: {
		padding: theme.spacing(1)
	},

	inputLabel: {
		position: "absolute",
		left: 0,
		top: 0,
		transform: "translate(0, 24px) scale(1)",

		fontSize: "18px",
		fontWeight: 400,
		// color: grayColor[5]
		color: 'var(--legend-label-text)'
	},
	
	outline: {
		borderRadius: 5,
		// borderColor: grayColor[2]
		borderColor: 'var(--legend-border-color)'
	},

	errorMsg: {
		marginTop: theme.spacing(0.5),
		marginLeft: theme.spacing(2)
	}
})

export default legendStyle